module.exports = __webpack_public_path__ + "img/13.855e21c8.png";